import { Fragment, useEffect } from "react";
import { openQuickModal } from "../../store/modal/ModalSlicer";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Loader from "../../component/Loader";
import { baseUrl } from "../../utils/APi";
import { Link, useNavigate } from "react-router-dom";
import { delfromfav, getfav } from "../../store/cart/cartAction";

import img1 from "../../assets/main/1.jpg";
import img2 from "../../assets/team/team-member-post-1.jpg";
import img3 from "../../assets/team/team-member-post-2.jpg";
import img4 from "../../assets/team/team-member-post-3.jpg";
import img5 from "../../assets/team/team-member-post-4.jpg";
import img6 from "../../assets/team/team-member-post-5.jpg";
import img7 from "../../assets/team/team-member-post-6.jpg";
const Team = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const lan = useSelector((state) => state.LanSlicer.language);
  const { token, user } = useSelector((state) => state.authSlice);
  const { favlist, loading } = useSelector((state) => state.cartSlice);

  return (
    <Fragment>
      <section
        class="flat-title-page back-ground-style"
        style={{ backgroundImage: `url(${img1})` }}
      >
        <div class="container-fluid">
          <div class="row">
            <div class="breadcrumbs text-center link-style-5 text-white">
              <h2 class="section-title-page">Our Team</h2>
              <ul class="breadcrumbs-inner list-center display-flex">
                <li>
                  <a
                    class="section-16px-regular font-weight-500"
                    href="index.html"
                  >
                    Home
                  </a>
                </li>
                <li>
                  <h4 class="section-16px-regular font-weight-500">Team</h4>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <section class="flat-team-member">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <div class="section-title wow fadeInDown">
                <h4 class="section-subtitle">Our Team</h4>
                <h2 class="section-30px-montserrat margin-top-27">
                  We draw on our global network to
                  <br />
                  assemble a team of experts.
                </h2>
              </div>
            </div>
            <div class="col-md-4">
              <div
                class="team-member-box wow fadeInUp"
                data-wow-delay="0ms"
                data-wow-duration="1500ms"
              >
                <div class="team-images">
                  <img src={img2} alt="images" />
                  <div class="team-socials ">
                    <ul class="entry-socials">
                      <li>
                        <a href="#">Fb.</a>
                      </li>
                      <li>
                        <a href="#">Be.</a>
                      </li>
                      <li>
                        <a href="#">Tw.</a>
                      </li>
                      <li>
                        <a href="#">In.</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="team-info">
                  <div class="team-name">
                    <a href="#" class="section-22px-montserrat">
                      Fran Bostick
                    </a>
                  </div>
                  <div class="team-job">
                    <h4 class="section-14px-regular font-weight-500">
                      Founder & CEO
                    </h4>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div
                class="team-member-box wow fadeInUp"
                data-wow-delay="300ms"
                data-wow-duration="1500ms"
              >
                <div class="team-images">
                  <img src={img3} alt="images" />
                  <div class="team-socials ">
                    <ul class="entry-socials">
                      <li>
                        <a href="#">Fb.</a>
                      </li>
                      <li>
                        <a href="#">Be.</a>
                      </li>
                      <li>
                        <a href="#">Tw.</a>
                      </li>
                      <li>
                        <a href="#">In.</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="team-info">
                  <div class="team-name">
                    <a href="#" class="section-22px-montserrat">
                      Tina Holt
                    </a>
                  </div>
                  <div class="team-job">
                    <h4 class="section-14px-regular font-weight-500">
                      Founder & CEO
                    </h4>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div
                class="team-member-box wow fadeInUp"
                data-wow-delay="600ms"
                data-wow-duration="1500ms"
              >
                <div class="team-images">
                  <img src={img7} alt="images" />
                  <div class="team-socials ">
                    <ul class="entry-socials">
                      <li>
                        <a href="#">Fb.</a>
                      </li>
                      <li>
                        <a href="#">Be.</a>
                      </li>
                      <li>
                        <a href="#">Tw.</a>
                      </li>
                      <li>
                        <a href="#">In.</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="team-info">
                  <div class="team-name">
                    <a href="#" class="section-22px-montserrat">
                      Charles Wilkinson
                    </a>
                  </div>
                  <div class="team-job">
                    <h4 class="section-14px-regular font-weight-500">
                      Founder & CEO
                    </h4>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div
                class="team-member-box wow fadeInUp"
                data-wow-delay="0ms"
                data-wow-duration="1500ms"
              >
                <div class="team-images">
                  <img src={img4} alt="images" />
                  <div class="team-socials ">
                    <ul class="entry-socials">
                      <li>
                        <a href="#">Fb.</a>
                      </li>
                      <li>
                        <a href="#">Be.</a>
                      </li>
                      <li>
                        <a href="#">Tw.</a>
                      </li>
                      <li>
                        <a href="#">In.</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="team-info">
                  <div class="team-name">
                    <a href="#" class="section-22px-montserrat">
                      Suzanne Higgins
                    </a>
                  </div>
                  <div class="team-job">
                    <h4 class="section-14px-regular font-weight-500">
                      Founder & CEO
                    </h4>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div
                class="team-member-box wow fadeInUp"
                data-wow-delay="300ms"
                data-wow-duration="1500ms"
              >
                <div class="team-images">
                  <img src={img5} alt="images" />
                  <div class="team-socials ">
                    <ul class="entry-socials">
                      <li>
                        <a href="#">Fb.</a>
                      </li>
                      <li>
                        <a href="#">Be.</a>
                      </li>
                      <li>
                        <a href="#">Tw.</a>
                      </li>
                      <li>
                        <a href="#">In.</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="team-info">
                  <div class="team-name">
                    <a href="#" class="section-22px-montserrat">
                      Michael Alan Tate
                    </a>
                  </div>
                  <div class="team-job">
                    <h4 class="section-14px-regular font-weight-500">
                      Founder & CEO
                    </h4>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div
                class="team-member-box wow fadeInUp"
                data-wow-delay="600ms"
                data-wow-duration="1500ms"
              >
                <div class="team-images">
                  <img src={img6} alt="images" />
                  <div class="team-socials ">
                    <ul class="entry-socials">
                      <li>
                        <a href="#">Fb.</a>
                      </li>
                      <li>
                        <a href="#">Be.</a>
                      </li>
                      <li>
                        <a href="#">Tw.</a>
                      </li>
                      <li>
                        <a href="#">In.</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="team-info">
                  <div class="team-name">
                    <a href="#" class="section-22px-montserrat">
                      Fran Bostick
                    </a>
                  </div>
                  <div class="team-job">
                    <h4 class="section-14px-regular font-weight-500">
                      Founder & CEO
                    </h4>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="team-button text-center wow fadeInUp">
                <a
                  href="#"
                  class="button-footer arrow-btn btn-st style-3 margin-top-48"
                >
                  View All Member
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="flat-contact-me">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-md-7">
              <div class="contact-me-content wow fadeInUp">
                <h4 class="section-subtitle">Hire Me</h4>
                <h2 class="section-45px-montserrat margin-top-15 margin-bottom-45">
                  Any Project in your mind
                </h2>
                <div class="button-contact-me wow fadeInDown">
                  <a href="contact.html" class="button-footer arrow-btn btn-st">
                    Hire Me Now
                  </a>
                  <a
                    href="#"
                    class="button-footer clound-down btn-st style-4 border-white"
                  >
                    Download CV
                  </a>
                </div>
              </div>
            </div>
            <div class="col-md-5">
              <div class="contact-me-post wow fadeInRight">
                <img src={img1} alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default Team;
